module.exports = __webpack_public_path__ + "static/img/1.a0a8075.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/eng/1.png
// module id = aqIv
// module chunks = 0